import { render, staticRenderFns } from "./CustomerAndSellerBlacklist.vue?vue&type=template&id=bb18efee&scoped=true"
import script from "./CustomerAndSellerBlacklist.vue?vue&type=script&lang=js"
export * from "./CustomerAndSellerBlacklist.vue?vue&type=script&lang=js"
import style0 from "./CustomerAndSellerBlacklist.vue?vue&type=style&index=0&id=bb18efee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb18efee",
  null
  
)

export default component.exports